import ApplicantForm from "./ApplicantForm"
import LegalApplicantForm from "./LegalApplicantForm"
import { countries, nationalities } from "../../../utils/countryData"

export default function NaturalApplicantForm({
  onCancel,
  onSave,
  initialValues,
}: {
  onCancel: () => void
  onSave: (data: any) => void
  initialValues?: Record<string, any>
}) {
  const isEditing = !!initialValues
  const isEuipoPerson = !!initialValues?.euipoPersonIdentifier
  const formType = initialValues?.type || "natural"

  if (formType === "legal" && !isEditing) {
    return (
      <LegalApplicantForm
        onCancel={onCancel}
        onSave={onSave}
        initialValues={{ ...(initialValues ?? {}), type: "legal" }}
      />
    )
  }

  const fields = [
    { name: "firstName", label: "First name", required: true },
    { name: "lastName", label: "Last name", required: true },
    { name: "nationality", label: "Nationality", options: nationalities },
    { name: "address.street", label: "Street and house number", required: true },
    { name: "address.city", label: "City", required: true },
    { name: "address.postalCode", label: "Postal code", required: true },
    {
      name: "address.country",
      label: "Country",
      required: true,
      options: countries,
    },
    { name: "contact.phone", label: "Phone" },
    { name: "contact.email", label: "Email" },
  ]

  return (
    <ApplicantForm
      readOnly={isEuipoPerson}
      fields={isEuipoPerson ? [] : fields}
      initialValues={initialValues}
      onCancel={onCancel}
      onSave={(data) => {
        if (isEuipoPerson) {
          onSave({
            type: "natural",
            euipoPersonIdentifier: initialValues!.euipoPersonIdentifier,
          })
          return
        }

        onSave({ ...data, type: "natural" })
      }}
    />
  )
}
